import { attr, html, Value, When } from '@tempots/dom'
import { Anchor } from '@tempots/ui'

export type LogoSize = 'sm' | 'md' | 'lg'

export interface LogoOptions {
  displaySlogan?: Value<boolean>
  size?: Value<LogoSize>
}

export function Logo({ displaySlogan = true, size = 'md' }: LogoOptions = {}) {
  const sizeClass = Value.map(size, (size) => {
    switch (size) {
      case 'sm':
        return 'w-10 h-10'
      case 'md':
        return 'w-16 h-16'
      case 'lg':
        return 'w-24 h-24'
    }
  })
  return html.div(
    attr.class('flex items-center justify-center'),
    Anchor(
      { href: '/' },
      attr.class('flex items-center gap-3 group'),
      // Icon/Logo
      html.div(
        attr.class(
          'rounded-xl bg-gradient-to-br from-sky-50 to-sky-100 flex items-center justify-center shadow-md group-hover:shadow-lg transition-shadow text-sky-700 border border-sky-100 p-2'
        ),
        attr.class(sizeClass),
        html.img(attr.src('/logo.svg'))
      ),
      When(displaySlogan, () =>
        html.div(
          attr.class('flex flex-col'),
          html.span(
            attr.class(
              'text-2xl font-bold text-gray-900 dark:text-white group-hover:text-primary-600 dark:group-hover:text-primary-400 transition-colors'
            ),
            'Verts'
          ),
          html.span(
            attr.class('text-xs text-gray-500 dark:text-gray-400'),
            'APIs that speed you up'
          )
        )
      )
    )
  )
}
